import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

function ProductName({ intl, name, type, drm, vrSupport }) {
  if (!name || !type) return false;
  const { formatMessage } = intl;

  const messages = defineMessages({
    steamgame: {
      id: 'product-header.steamgame',
      defaultMessage: 'Steam Game',
    },
    epic: {
      id: 'product-header.epicgame',
      defaultMessage: 'Epic Games',
    },
    download: { // * switch download? or code?
      id: 'product-header.download',
      defaultMessage: 'Download',
    },
    game: {
      id: 'product-header.game.game',
      defaultMessage: 'Game',
    },
  });

  if (vrSupport && drm.oculus && (
    vrSupport.oculus_meta_quest ||
    vrSupport.oculus_meta_quest_two ||
    vrSupport.oculus_meta_quest_three
  )) {
    return `${name} - Quest VR`;
  }

  if (name.length <= 7 && type === 'game') {
    if (drm.steam && Object.keys(drm).filter(k => drm[k]).length === 1) {
      return `${name} - ${formatMessage(messages.steamgame)}`;
    }

    if (drm.epicgames && Object.keys(drm).filter(k => drm[k]).length === 1) {
      return `${name} - ${formatMessage(messages.epic)}`;
    }

    return `${name} - ${formatMessage(messages.game)}`;
  }

  return name;
}

ProductName.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  drm: PropTypes.shape({}).isRequired,
  vrSupport: PropTypes.shape({}),
};

ProductName.defaultProps = {
  vrSupport: {},
};

export default injectIntl(ProductName);
